import axios from "axios";

const categorias = {
  state: () => ({
    saberesCompetencia: [],
    saberCompetencia: {},
  }),

  getters: {
    obtenerSaberesCompetencia(state) {
      return state.saberesCompetencia;
    },

    obtenerSaberCompetencia(state) {
      return state.saberCompetencia;
    }
  },

  mutations: {
    enviarSaberesCompetencia(state, saberes) {
      state.saberesCompetencia = saberes;
    },

    enviarSaberCompetencia(state, saber) {
      state.saberCompetencia = saber;
    },
  },

  actions: {
    registrarSaberCompetencia(context, { idCompetencia, saber }) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/campesena/competencias/${idCompetencia}/categorias`, saber)
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            reject();
          });
      });
    },

    gestionarSaberesCompetencia(context, idCompetencia) {
      axios.get(`/api/campesena/competencias/${idCompetencia}/categorias`)
      .then((response) => {
        const saberes = [];
        
        response.data.results.forEach((saber) => {
          saberes.push({
            id: saber.saber_id,
            saber: saber.saber.saber,
            modalidad_id: saber.modalidad_id,
            modalidad: saber.modalidad.modalidad,
            numero_participantes: saber.numero_participantes,
            cantidad_grupos: saber.cantidad_grupos,
            categoria_id: saber.saber.categoria_id
          });
        });
        
        context.commit("enviarSaberesCompetencia", saberes);
      })
      .catch(() => {});
    },

    obtenerSaberCompetenciaId(context, { idCompetencia, idSaber}) {
      axios.get(`/api/campesena/competencias/${idCompetencia}/categorias/${idSaber}`)
      .then((response) => {
          const detalles = response.data.results
    
          const saberCompetencia =  {
            saber_id: detalles.saber_id,
            saber: detalles.saber.saber,
            modalidad_id: detalles.modalidad_id,
            modalidad: detalles.modalidad.modalidad,
            numero_participantes: detalles.numero_participantes,
            cantidad_grupos: detalles.cantidad_grupos,
            categoria_id: detalles.saber.categoria_id,
            competencia: detalles.competencia.competencia
          }
    
          context.commit("enviarSaberCompetencia", saberCompetencia);
      })
      .catch(() => {})
    },

    actualizarSaberCompetencia( context,{ idCompetencia, idSaber, saber }) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/campesena/competencias/${idCompetencia}/categorias/${idSaber}`, saber)
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    },

    eliminarSaberCompetencia(context, { idCompetencia, idSaber }) {
      return new Promise((resolve, reject) => {
        axios.delete( `/api/campesena/competencias/${idCompetencia}/categorias/${idSaber}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch(() => {
          reject();
        });
      });
    }, 
  },
};

export default categorias;
